(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll", "newWindow", "forceReload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      newWindow = _ref.newWindow,
      forceReload = _ref.forceReload,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    var cardLink = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      href: forceReload ? link : undefined,
      target: newWindow ? '_blank' : undefined,
      rel: newWindow ? 'noopener noreferrer' : undefined,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
    });

    if (forceReload) return cardLink;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: cardLink
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 57613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ LinkCardList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32125);

var LinkCardList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LinkCardList",
  componentId: "sc-1coeyv8-0"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(316px,max-content));justify-content:center;gap:46px;@media screen and (max-width:1047px){gap:22px;}"]);

/***/ }),

/***/ 54399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ NewsItem; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49642);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16645);
/* harmony import */ var _NewsTag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62816);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var NewsItem = function NewsItem(_ref) {
  var publishDate = _ref.publishDate,
      tag = _ref.tag,
      title = _ref.title,
      link = _ref.link,
      isNotShowBottom = _ref.isNotShowBottom;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Article, {
    isNotShowBottom: isNotShowBottom,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: link,
      passHref: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(Anchor, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Time, {
          dateTime: publishDate,
          children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_6__/* .formatDate */ .p6)(publishDate, 'yyyy/MM/dd')
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(NewsDiv, {
          children: [tag.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(TagList, {
            children: tag.map(function (value) {
              return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_5__.createElement)(_NewsTag__WEBPACK_IMPORTED_MODULE_3__/* .NewsTag */ .a, _objectSpread(_objectSpread({}, value), {}, {
                key: value.name
              }));
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Title, {
            children: title
          })]
        })]
      })
    })
  });
};
var Article = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].article.withConfig */ .ZP.article.withConfig({
  displayName: "NewsItem__Article",
  componentId: "sc-1vsdgpn-0"
})(["padding-bottom:30px;:not(:last-of-type){border-bottom:", ";}@media screen and (max-width:1047px){padding-bottom:26px;}"], function (_ref2) {
  var isNotShowBottom = _ref2.isNotShowBottom;
  return isNotShowBottom ? "none" : "1px solid ".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue);
});
var Anchor = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "NewsItem__Anchor",
  componentId: "sc-1vsdgpn-1"
})(["display:flex;cursor:pointer;gap:50px;&:hover > div > h3{text-decoration:underline;color:", ";}@media screen and (max-width:1047px){flex-direction:column;row-gap:14px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var Time = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].time.withConfig */ .ZP.time.withConfig({
  displayName: "NewsItem__Time",
  componentId: "sc-1vsdgpn-2"
})(["font-size:14px;font-weight:bold;line-height:24px;letter-spacing:0;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.textTitle */ .r.colors.textTitle);
var NewsDiv = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "NewsItem__NewsDiv",
  componentId: "sc-1vsdgpn-3"
})(["display:flex;flex-direction:column;row-gap:14px;"]);
var TagList = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "NewsItem__TagList",
  componentId: "sc-1vsdgpn-4"
})(["display:flex;flex-wrap:wrap;gap:12px;"]);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "NewsItem__Title",
  componentId: "sc-1vsdgpn-5"
})(["font-size:16px;letter-spacing:0.64px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:15px;line-height:24px;letter-spacing:0;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.textTitle */ .r.colors.textTitle);

/***/ }),

/***/ 62816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ NewsTag; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var NewsTag = function NewsTag(tag) {
  var tagColor = tag.code === 'importantNotices' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.red */ .r.colors.red : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Tag, {
    color: tagColor,
    children: tag.name
  });
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "NewsTag__Tag",
  componentId: "sc-1gokp8z-0"
})(["font-size:13px;text-align:center;line-height:1;color:", ";list-style:none;min-width:82px;padding:6px 13px;border:1pt solid;border-radius:2pt;border-color:", ";color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
});

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 75795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SectionTitleBackground; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "showTopArrow"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SectionTitleBackground = function SectionTitleBackground(_ref) {
  var children = _ref.children,
      _ref$showTopArrow = _ref.showTopArrow,
      showTopArrow = _ref$showTopArrow === void 0 ? true : _ref$showTopArrow,
      rest = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, _objectSpread(_objectSpread({
    showTopArrow: showTopArrow
  }, rest), {}, {
    children: children
  }));
};
var Arrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["content:'';position:absolute;left:0;width:0;height:0;border-style:solid;border-width:175px 50vw 0 50vw;@media screen and (max-width:1047px){border-width:40px 50vw 0 50vw;}"]);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitleBackground__Wrapper",
  componentId: "sc-venkor-0"
})(["position:relative;background-color:", ";padding:", ";&::before{", ";}&::after{", ";bottom:0;border-color:", ";}@media screen and (max-width:1047px){padding:", ";}"], function (_ref2) {
  var bgColor = _ref2.bgColor;
  return bgColor === 'trial-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : bgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff';
}, function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var _ref4$showTopArrow = _ref4.showTopArrow,
      showTopArrow = _ref4$showTopArrow === void 0 ? true : _ref4$showTopArrow,
      outerBgColor = _ref4.outerBgColor;
  return showTopArrow ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["", ";top:0;border-color:", " transparent transparent transparent;"], Arrow, outerBgColor === 'thin-blue' ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue : '#fff') : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["content:none;"]);
}, Arrow, function (_ref5) {
  var bgColor = _ref5.bgColor,
      outerBgColor = _ref5.outerBgColor;
  return "".concat(bgColor === 'trial-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : bgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      ").concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      transparent \n      ").concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff');
}, function (_ref6) {
  var padding = _ref6.padding;
  return padding.sp;
});

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Os": function() { return /* binding */ AHeading; },
/* harmony export */   "V": function() { return /* binding */ CHeading; },
/* harmony export */   "Zg": function() { return /* binding */ BHeading; },
/* harmony export */   "ac": function() { return /* binding */ DHeading; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var AHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__AHeading",
  componentId: "sc-ywkeww-0"
})(["font-size:28px;font-weight:700;line-height:1.2;color:", ";border-bottom:1px solid ", ";padding-bottom:22px;margin-bottom:50px;@media screen and (max-width:1047px){font-size:19px;padding-bottom:10px;margin-bottom:30px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey);
var BHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "Heading__BHeading",
  componentId: "sc-ywkeww-1"
})(["font-size:24px;font-weight:700;line-height:140%;color:", ";margin-bottom:36px;@media screen and (max-width:1047px){font-size:20px;line-height:130%;margin-bottom:26px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var CHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Heading__CHeading",
  componentId: "sc-ywkeww-2"
})(["font-size:18px;font-weight:700;line-height:140%;margin-bottom:20px;@media screen and (max-width:1047px){font-size:16px;line-height:130%;margin-bottom:18px;}"]);
var DHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__DHeading",
  componentId: "sc-ywkeww-3"
})(["font-size:32px;font-weight:700;line-height:100%;color:", ";@media screen and (max-width:1047px){font-size:24px;line-height:130%;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 11318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ RecentNewsList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _hooks_useMpocketScript__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98259);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var RecentNewsList = function RecentNewsList() {
  (0,_hooks_useMpocketScript__WEBPACK_IMPORTED_MODULE_1__/* .useMpocketScript */ .k)('//irpocket.com/141A/irpocket/config-utils-main.js'); // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(NewsList, {
    id: "irp-top-list"
  });
};
var NewsList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RecentNewsList__NewsList",
  componentId: "sc-1ffy42j-0"
})(["display:flex;flex-direction:column;gap:30px;@media screen and (max-width:1047px){gap:24px;}> article{padding-bottom:30px;:not(:last-child){border-bottom:1px solid ", ";}@media screen and (max-width:1047px){padding-bottom:24px;}> a{display:flex;cursor:pointer;gap:50px;&:hover > div > h3{> svg{fill:", ";}> p{text-decoration:underline;color:", ";> span{color:", ";display:inline-block;}}}@media screen and (max-width:1047px){flex-direction:column;row-gap:14px;}> time{font-weight:700;font-size:14px;line-height:1.6;letter-spacing:0;color:", ";}> div{display:flex;flex-direction:column;row-gap:14px;> ul{display:flex;flex-wrap:wrap;gap:12px;> li{font-size:13px;text-align:center;line-height:1;color:", ";list-style:none;min-width:82px;padding:6px 13px;border:1pt solid;border-radius:2pt;border-color:", ";}}> h3{display:flex;gap:10px;transition:fill 0.3s ease;@media screen and (max-width:1047px){font-size:15px;line-height:24px;letter-spacing:0;}> svg{fill:", ";width:12px;height:28px;flex-shrink:0;}> p{font-size:16px;letter-spacing:0.64px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:15px;}> span{font-weight:500;font-size:13px;line-height:1.6;color:", ";margin-left:10px;@media screen and (max-width:1047px){font-size:11px;}}}}}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond);

/***/ }),

/***/ 98259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useMpocketScript; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


// 修正案1

console.log('4');
var useMpocketScript = function useMpocketScript(src) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      error = _useState2[0],
      setError = _useState2[1]; // エラー状態をstringまたはnullで初期化


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (false) {} // SSR対策

    var loadScript = /*#__PURE__*/function () {
      var _ref = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return new Promise(function (resolve, reject) {
                  var scriptElement = document.createElement('script');
                  var srcWithTime = src;
                  var time = new Date().getTime();

                  if (srcWithTime.includes('?')) {
                    srcWithTime += "&_t=".concat(time);
                  } else {
                    srcWithTime += "?_t=".concat(time);
                  }

                  scriptElement.src = srcWithTime;
                  scriptElement.async = true;
                  console.log('scriptElement.src:', scriptElement.src);
                  document.body.appendChild(scriptElement); // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);

                  // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);
                  var existingScript = document.querySelector("script[src*=\"".concat(src, "\"]"));

                  if (existingScript) {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u65E2\u306B\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u3059: ".concat(src));
                    resolve(existingScript);
                    return;
                  } else {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u305B\u3093\u3001\u8FFD\u52A0\u3057\u307E\u3059: ".concat(src));
                  } // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;


                  // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;
                  scriptElement.onload = function () {
                    console.log('マジカルポケットの外部スクリプトが読み込まれました。');
                    console.log('scriptElement.src:', scriptElement.src);
                    setIsLoaded(true);
                    resolve(scriptElement);
                  };

                  scriptElement.onerror = function () {
                    var errorMessage = 'マジカルポケットの外部スクリプトの読み込みに失敗しました。';
                    console.error(errorMessage);
                    setError(errorMessage); // カスタムエラーメッセージをセット

                    // カスタムエラーメッセージをセット
                    reject(new Error(errorMessage));
                  }; // document.body.appendChild(scriptElement);


                  // document.body.appendChild(scriptElement);
                  console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304CDOM\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F: ".concat(src));
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                setError(_context.t0 instanceof Error ? _context.t0.message : String(_context.t0));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function loadScript() {
        return _ref.apply(this, arguments);
      };
    }();

    loadScript();
  }, [src]);
  return {
    isLoaded: isLoaded,
    error: error
  };
};
/*
import { useEffect, useState } from 'react';

export const useMpocketScript = (src: string) => {
  const [isLoaded, setIsLoaded] = useState(false);  // スクリプト(js)読込状況の確認用
  const [error, setError] = useState<string | null>(null);  // エラーメッセージ格納用

  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR対策とスクリプト読み込みフラグ確認

    const loadScript = () => {
      //Promiseを利用した非同期処理
      //各種読み込み状態・処理状態に応じた処理を行うため、Promiseを使用
      return new Promise((resolve, reject) => {
        // 既に同じsrcのスクリプトが存在するか確認
        const existingScript = document.querySelector(`script[src="${src}"]`);  

        if (existingScript) { // 存在している場合
          console.log(`スクリプトが既にページに存在します: ${src}`);
          setIsLoaded(true);
          resolve(existingScript);
          return;
        }
        
        // 新しいスクリプト要素の作成
        const scriptElement = document.createElement('script');
        scriptElement.src = src;
        scriptElement.async = true; // 非同期での読込。可読性重視のため、asyncを採用

        // スクリプトの読込成功時
        scriptElement.onload = () => {
          console.log('外部スクリプトが読み込まれました。');
          setIsLoaded(true);
          resolve(scriptElement);
        };

        // スクリプトの読込失敗時
        scriptElement.onerror = () => {
          const errorMessage = '外部スクリプトの読み込みに失敗しました。';
          console.error(errorMessage);
          setError(errorMessage);
          reject(new Error(errorMessage));  //エラーで拒否
        };

        // スクリプトをDOMに追加
        const appendScript = () => {
          if (document.body) {
            document.body.appendChild(scriptElement);
            console.log(`スクリプトがDOMに追加されました: ${src}`);
          } else {
            console.error('document.bodyが存在しません。スクリプトの追加に失敗しました。');
            reject(new Error('document.bodyが存在しません。スクリプトの追加に失敗しました。')); //エラーで拒否
          }
        };

        // ドキュメントの準備状態に応じて作業を変更
        if (document.readyState === 'loading') {   // ドキュメントが読み込み中の場合
          document.addEventListener('DOMContentLoaded', appendScript);
        } else {  // ドキュメントが読み込み済みの場合
          appendScript();
        }
      });
    };

    // スクリプトを同期的に読込
    //　可読性重視、ハンドリングの容易さを重視しての、async選択
    const syncLoadScript = async () => {
      try {
        await loadScript(); // スクリプトの読み込み待ち
      } catch (error) { // エラーが発生時
        setError(error instanceof Error ? error.message : String(error));
      }
    };

    syncLoadScript(); // スクリプトの同期読込
  }, [src]);

  return { isLoaded, error };
};

*/

/***/ }),

/***/ 12512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(36797);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/utils/convertPx.ts
var convertPx = __webpack_require__(98993);
// EXTERNAL MODULE: ./src/utils/routes.ts
var routes = __webpack_require__(97749);
// EXTERNAL MODULE: ./src/components/elements/LinkCard/index.tsx + 1 modules
var LinkCard = __webpack_require__(53300);
// EXTERNAL MODULE: ./src/components/elements/LinkCardList/index.tsx
var LinkCardList = __webpack_require__(57613);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Home/IrPickUp.tsx








var IrPickUp = function IrPickUp() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Investor Relations",
      subTitleText: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 34,
        pc: 70
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCardList/* LinkCardList */.s, {
      children: routes/* IR_PICKUP_ROUTE.map */.UT.map(function (_ref) {
        var path = _ref.path,
            name = _ref.name,
            imagePath = _ref.imagePath;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCard/* LinkCard */.k, {
          link: path,
          title: name,
          imgPath: imagePath
        }, path);
      })
    })]
  });
};
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrPickUp__Container",
  componentId: "sc-1gz9fxz-0"
})(["width:1040px;margin:100px auto 130px;@media screen and (max-width:1047px){margin:60px auto 60px;width:100%;padding:0 20px;}"]);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/elements/Button/index.tsx
var Button = __webpack_require__(96738);
// EXTERNAL MODULE: ./src/components/elements/News/NewsItem/index.tsx
var NewsItem = __webpack_require__(54399);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/pages/Ir/RecentNewsList.tsx
var RecentNewsList = __webpack_require__(11318);
;// CONCATENATED MODULE: ./src/components/pages/Home/News.tsx









var News = function News(_ref) {
  var newsRelease = _ref.newsRelease;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(NewsRoom, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SubSectionTitle, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* DHeading */.ac, {
        children: "\u30CB\u30E5\u30FC\u30B9\u30EA\u30EA\u30FC\u30B9"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/news/release/",
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsMoreButton, {
            btnStyle: "transparent",
            children: "\u4E00\u89A7\u3092\u898B\u308B"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 80
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PRNewsList, {
      children: newsRelease.map(function (_ref2, index) {
        var _id = _ref2._id,
            tag = _ref2.tag,
            title = _ref2.title,
            publishDate = _ref2.publishDate;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NewsItem/* NewsItem */.n, {
          publishDate: publishDate,
          tag: tag,
          title: title,
          link: "/news/release/".concat(_id),
          isNotShowBottom: index === 2
        }, _id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 34,
        pc: 90
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SubSectionTitle, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* DHeading */.ac, {
        children: "IR\u30CB\u30E5\u30FC\u30B9"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/ir/news/",
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsMoreButton, {
            btnStyle: "transparent",
            children: "\u4E00\u89A7\u3092\u898B\u308B"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 80
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IRNewsList, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RecentNewsList/* RecentNewsList */.M, {})
    })]
  });
};
var NewsRoom = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "News__NewsRoom",
  componentId: "sc-1x2nzlg-0"
})(["width:1040px;margin:100px auto 0;@media screen and (max-width:1047px){width:100%;margin:40px auto 0;}"]);
var SubSectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "News__SubSectionTitle",
  componentId: "sc-1x2nzlg-1"
})(["display:flex;align-items:center;gap:30px;@media screen and (max-width:1047px){gap:10px;padding:0 20px;}"]);
var PRNewsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "News__PRNewsList",
  componentId: "sc-1x2nzlg-2"
})(["display:flex;flex-direction:column;gap:24px;&[aria-hidden='true']{display:none;}@media screen and (max-width:1047px){padding:0 20px;}"]);
var IRNewsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "News__IRNewsList",
  componentId: "sc-1x2nzlg-3"
})(["&[aria-hidden='true']{display:none;}@media screen and (max-width:1047px){padding:0 20px;}"]);
var NewsMoreButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "News__NewsMoreButton",
  componentId: "sc-1x2nzlg-4"
})(["padding:11px 26px 13px 26px;width:135px;height:40px;font-size:16px;font-weight:500;@media screen and (max-width:1047px){padding:2px 18px 4px 18px;font-size:13px;width:104px;height:32px;}"]);
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
;// CONCATENATED MODULE: ./src/components/pages/Home/PickUpItem.tsx






var PickUpItem = function PickUpItem(_ref) {
  var link = _ref.link,
      imgPath = _ref.imgPath,
      imgWidth = _ref.imgWidth,
      imgHeight = _ref.imgHeight,
      title = _ref.title,
      alignItems = _ref.alignItems,
      cssProp = _ref.cssProp;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpItemStyled, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PickUpItemImage, {
          alignItems: alignItems,
          cssProp: cssProp,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: imgPath,
            alt: title,
            width: imgWidth,
            height: imgHeight
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpItemTitle, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              children: title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpLine, {
              color: "trialBlue",
              direction: "horizon",
              weight: 4
            })]
          })
        })]
      })
    })
  });
};
var PickUpItemStyled = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "PickUpItem__PickUpItemStyled",
  componentId: "sc-1acujya-0"
})(["background-color:white;border-radius:8px;width:311px;a{display:flex;flex-direction:column;align-items:center;padding:45px 0;img{transition:opacity 0.25s ease;}&:hover{h3{color:", ";}img{opacity:0.6;}}}@media screen and (max-width:1047px){height:164px;width:100%;max-width:350px;a{padding:20px 10% 24px;flex-direction:row;height:100%;}}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var PickUpLine = (0,styled_components_browser_esm/* default */.ZP)(Line/* Line */.x).withConfig({
  displayName: "PickUpItem__PickUpLine",
  componentId: "sc-1acujya-1"
})(["transition:background-color 0.25s ease;", ":hover &{background-color:", ";}"], PickUpItemStyled, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var PickUpItemImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PickUpItem__PickUpItemImage",
  componentId: "sc-1acujya-2"
})(["width:185px;height:185px;display:flex;flex-direction:column;justify-content:end;position:relative;width:185px;height:185px;border-radius:50%;background-color:", ";align-items:", ";@media screen and (max-width:1047px){width:90px;height:90px;justify-content:center;", ";}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue, function (_ref2) {
  var alignItems = _ref2.alignItems;
  return alignItems;
}, function (_ref3) {
  var cssProp = _ref3.cssProp;
  return cssProp;
});
var PickUpItemTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PickUpItem__PickUpItemTitle",
  componentId: "sc-1acujya-3"
})(["margin-top:22px;h3{font-size:20px;font-weight:bold;line-height:29px;margin-bottom:8px;transition:color 0.25s ease;}@media screen and (max-width:1047px){width:50%;margin-top:0;margin-left:13px;flex:1;text-align:center;> div{display:inline-block;}h3{text-align:center;margin-bottom:0;}}@media screen and (max-width:360px){h3{font-size:16px;}}"]);
// EXTERNAL MODULE: ./src/components/elements/SectionTitleBackground/index.tsx
var SectionTitleBackground = __webpack_require__(75795);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/Home/index.tsx


















swiper_esm/* default.use */.ZP.use([swiper_esm/* Pagination */.tl, swiper_esm/* Navigation */.W_, swiper_esm/* Autoplay */.pt]);
var HomePage = function HomePage(_ref) {
  var newsRelease = _ref.newsRelease;
  var images = ['/images/home-slide-1.webp', '/images/home-slide-2.webp', '/images/home-slide-3.webp', '/images/home-slide-4.webp', '/images/home-slide-5.webp'];
  var pickupList = [{
    link: '/company/topmessage/',
    imgPath: '/images/home-top-message.svg',
    imgWidth: 133,
    imgHeight: 174,
    title: 'トップメッセージ',
    alignItems: 'flex-end',
    cssProp: (0,styled_components_browser_esm/* css */.iv)(["img{max-width:100%;transform:translateX(23%);}"])
  }, {
    link: '/company/philosophy/',
    imgPath: '/images/home-philosophy.svg',
    imgWidth: 100,
    imgHeight: 195,
    title: '経営理念',
    alignItems: 'center',
    cssProp: (0,styled_components_browser_esm/* css */.iv)(["img{max-height:120px;}"])
  }, {
    link: '/news/blog/',
    imgPath: '/images/home-pr-blog.svg',
    imgWidth: 186,
    imgHeight: 147,
    title: '広報ブログ',
    alignItems: 'center',
    cssProp: (0,styled_components_browser_esm/* css */.iv)(["img{max-width:112px;transform:translateY(6%);}"])
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* Layout */.Ar, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
        title: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9 | \u30EA\u30C6\u30FC\u30EBDX\u3092\u901A\u3058\u3066\u4E16\u306E\u4E2D\u3092\u8C4A\u304B\u306A\u793E\u4F1A\u3078",
        hasTitleSuffix: false,
        description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306F\u300C\u4E16\u754C\u306E\u8AB0\u3082\u304C\u8C4A\u304B\u3055\u3092\u4EAB\u53D7\u3067\u304D\u308B\u793E\u4F1A\u3092\u3064\u304F\u308B\u3002\u300D\u3092\u30D3\u30B8\u30E7\u30F3\u306B\u63B2\u3052\u3001\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3068\u3001\u4EBA\u306E\u7D4C\u9A13\u77E5\u3067\u3001\u4E16\u754C\u306E\u30EA\u30A2\u30EB\u30B3\u30DE\u30FC\u30B9\u306E\u5909\u9769\u3092\u4FC3\u9032\u3059\u308B\u4F01\u696D\u3067\u3059\u3002",
        ogp: {
          url: ''
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopSlider, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\u4E16\u754C\u306E\u8AB0\u3082\u304C\u300C\u8C4A\u304B\u3055\u300D\u3092", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u4EAB\u53D7\u3067\u304D\u308B\u793E\u4F1A\u3092\u3064\u304F\u308B\u3002"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
              style: {
                zIndex: 1
              },
              slidesPerView: 1,
              pagination: {
                clickable: true,
                bulletClass: "swiper-pagination-bullet custom-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active custom-bullet-active"
              },
              loop: true,
              autoplay: {
                delay: 4000,
                disableOnInteraction: false
              },
              speed: 2000,
              children: images.map(function (src, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(SlideImage, {
                    src: src,
                    alt: ""
                  })
                }, "".concat(index));
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(News, {
          newsRelease: newsRelease
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            pc: 30,
            sp: 50
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUp, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SectionTitleBackground/* SectionTitleBackground */.T, {
            padding: {
              pc: "".concat((0,convertPx/* PxToVw */.g)(210, 1440), " 0 ").concat((0,convertPx/* PxToVw */.g)(130, 1440)),
              sp: "87px 0 80px"
            },
            bgColor: "trial-blue",
            outerBgColor: "white",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
              color: "white",
              titleText: "Pick Up",
              subTitleText: "\u30D4\u30C3\u30AF\u30A2\u30C3\u30D7",
              as: "h2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpList, {
              children: pickupList.map(function (_ref2) {
                var link = _ref2.link,
                    imgPath = _ref2.imgPath,
                    title = _ref2.title,
                    imgWidth = _ref2.imgWidth,
                    imgHeight = _ref2.imgHeight,
                    alignItems = _ref2.alignItems,
                    cssProp = _ref2.cssProp;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpItem, {
                  link: link,
                  imgPath: imgPath,
                  title: title,
                  imgWidth: imgWidth,
                  imgHeight: imgHeight,
                  alignItems: alignItems,
                  cssProp: cssProp
                }, title);
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrPickUp, {})]
      })]
    })
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Home__Wrapper",
  componentId: "sc-1bgrg9y-0"
})(["overflow:hidden;"]);
var SlideImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Home__SlideImage",
  componentId: "sc-1bgrg9y-1"
})(["width:100vw;height:", ";"], (0,convertPx/* PxToVw */.g)(643, 1440));
var TopSlider = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Home__TopSlider",
  componentId: "sc-1bgrg9y-2"
})([".swiper-pagination{bottom:27px;}.swiper-pagination-bullet.custom-bullet{background-color:#fff;margin:0 18px !important;width:14px;height:14px;opacity:1;}.swiper-pagination-bullet-active.custom-bullet-active{background-color:", ";}@media screen and (max-width:1047px){.swiper-pagination{position:relative !important;bottom:5px;margin-top:13px;}.swiper-pagination-bullet.custom-bullet{width:11px;height:11px;background-color:", ";}.swiper-pagination-bullet-active.custom-bullet-active{background-color:", ";}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var PickUp = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Home__PickUp",
  componentId: "sc-1bgrg9y-3"
})(["> div::after{display:none;}"]);
var PickUpList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Home__PickUpList",
  componentId: "sc-1bgrg9y-4"
})(["margin:70px auto 0;display:flex;justify-content:space-around;column-gap:30px;width:1040px;@media screen and (max-width:1047px){width:100%;margin:34px auto 0;flex-direction:column;align-items:center;row-gap:30px;padding:0 20px;}"]);
var SlideWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Home__SlideWrapper",
  componentId: "sc-1bgrg9y-5"
})(["position:relative;p{z-index:2;top:", ";color:#fff;font-size:", ";font-weight:bold;letter-spacing:3.2px;line-height:46px;background-color:rgba(0,45,101,0.9);padding-top:", ";padding-left:", ";padding-bottom:", ";padding-right:20px;br{display:none;}}@media screen and (max-width:1000px){p{font-size:", ";letter-spacing:1.4px;line-height:26px;line-height:", ";padding-top:", ";padding-bottom:", ";padding-right:", ";padding-left:", ";br{display:block;}}}"], (0,convertPx/* PxToVw */.g)(110, 1440), (0,convertPx/* PxToVw */.g)(30, 1440), (0,convertPx/* PxToVw */.g)(20, 1440), (0,convertPx/* PxToVw */.g)(100, 1440), (0,convertPx/* PxToVw */.g)(20, 1440), (0,convertPx/* PxToVw */.g)(14, 390), (0,convertPx/* PxToVw */.g)(20, 390), (0,convertPx/* PxToVw */.g)(5, 390), (0,convertPx/* PxToVw */.g)(5, 390), (0,convertPx/* PxToVw */.g)(24, 390), (0,convertPx/* PxToVw */.g)(34, 390));
;// CONCATENATED MODULE: ./src/pages/index.tsx



var Home = function Home(_ref) {
  var newsRelease = _ref.newsRelease;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HomePage, {
    newsRelease: newsRelease
  });
};

var __N_SSG = true;
/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(12512);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,2167,5727,5548,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);